import gql from 'graphql-tag';

export const updateExpertoBannerPreference = gql`
  mutation updateExpertoBannerPreferenceUpdate($userId: ID!, $preferenceId: ID!, $showBanner: Boolean!) {
    updateExpertoBannerPreference(
      input: {
        userId: $userId,
        preferenceId: $preferenceId,
        showBanner: $showBanner
      }
    ) {
      id
      showBanner
      updatedAt
    }
  }
`;
